/**
 * The pack boards' extra icons (alignment map sprite, same 24×24 stroke style as the gate kit's):
 * pouch, QR, printer, play, leftover sack, carton, store, file. Added next to the gate and
 * processing sprites on every pack screen, so kit pieces that take an icon name can use them.
 */
import { PIcon, ProcessSprite, type PIconName } from '@/features/process/v1/icons'

export type PackIconName =
  'pouch' | 'qr' | 'printer' | 'play' | 'leftover' | 'carton' | 'store' | 'file'

export type KIconName = PIconName | PackIconName

const PACK_SPRITE =
  '<symbol id="ui-pouch" viewBox="0 0 24 24"><path d="M7 3h10l1 4v12a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V7z"/><path d="M6 7h12"/><path d="M9.5 12h5M9.5 15h5"/></symbol>' +
  '<symbol id="ui-qr" viewBox="0 0 24 24"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/><path d="M14 14h3v3h-3zM18 18h3v3h-3zM14 20.5h2M20.5 14v2"/></symbol>' +
  '<symbol id="ui-printer" viewBox="0 0 24 24"><rect x="6" y="3" width="12" height="6"/><rect x="3" y="9" width="18" height="8" rx="1.5"/><rect x="7" y="14" width="10" height="7"/></symbol>' +
  '<symbol id="ui-play" viewBox="0 0 24 24"><path d="M8 5v14l11-7z"/></symbol>' +
  '<symbol id="ui-leftover" viewBox="0 0 24 24"><path d="M6 8h12l1 12H5z"/><path d="M10 8l2-3 2 3"/><path d="M14.5 14.5a3 3 0 1 1-1-2.2"/><path d="M14 10.5v2h-2"/></symbol>' +
  '<symbol id="ui-carton" viewBox="0 0 24 24"><path d="M3 8l9-4 9 4v10l-9 4-9-4z"/><path d="M3 8l9 4 9-4M12 12v10"/></symbol>' +
  '<symbol id="ui-store" viewBox="0 0 24 24"><path d="M4 10l1.5-5h13L20 10M4 10v10h16V10M4 10h16"/><path d="M10 20v-5h4v5"/></symbol>' +
  '<symbol id="ui-file" viewBox="0 0 24 24"><path d="M6 3h9l4 4v14H6z"/><path d="M14 3v5h5"/></symbol>'

/** The processing and pack symbols, once per pack screen (absolutely placed, takes no room). */
export function PackSprite() {
  return (
    <>
      <ProcessSprite />
      <div
        aria-hidden="true"
        style={{ position: 'absolute', width: 0, height: 0, overflow: 'hidden' }}
        dangerouslySetInnerHTML={{ __html: `<svg>${PACK_SPRITE}</svg>` }}
      />
    </>
  )
}

export function KIcon(props: { name: KIconName; size?: number; sw?: number; color?: string }) {
  return <PIcon {...props} name={props.name as PIconName} />
}
